import React from "react";

import QuoteApproval from "../../page-components-nozod/quote-approval/QuoteApproval";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const QuoteDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const quoteId = searchParams.get("quoteid");
  const isCoveringManager = searchParams.get("coveringManager") === "true";
  const navigationData = location.state;

  const handleQuoteListNavigation = (event) => {
    event.preventDefault();
    navigate("/quotelist");
  };

  return (
    <QuoteApproval
      pdfViewer={true}
      quoteId={quoteId}
      quoteRecord={navigationData}
      isCoveringManager={isCoveringManager}
      handleCancel={handleQuoteListNavigation}
    />
  );
};

export default QuoteDetails;
